<script setup lang="ts">
import { Button, Icon } from '@easybell/caramel-vue3'
import { useFeaturesStore } from '@/stores/features/store'

const featuresStore = useFeaturesStore()

function close() {
  featuresStore.hideHelpTipsPopup()
}

function disableHelpTips() {
  featuresStore.toggleAreHelpTipsVisible()

  close()
}
</script>

<template>
  <div
    v-if="featuresStore.isHelpTipsPopupVisible"
    class="fixed bottom-34 right-14 z-30"
  >
    <div
      class="flex gap-2 relative w-80 bg-primary-100 border border-primary-500 p-4 rounded-lg"
    >
      <Icon
        name="Close"
        class="absolute top-2 right-2 size-7 p-1 cursor-pointer rounded-full hover:bg-neutral-200"
        @click="close()"
      />

      <div>
        <Icon name="LampSpark" size="1.5rem" />
      </div>

      <div class="flex flex-col gap-4">
        <div class="font-semibold">{{ $t('helpTips.popup.title') }}</div>

        <div>{{ $t('helpTips.popup.text') }}</div>

        <div class="flex flex-col gap-2">
          <div>
            <Button variant="primary" @click="close()">
              {{ $t('helpTips.popup.okButton') }}
            </Button>
          </div>

          <div>
            <Button variant="outlined" @click="disableHelpTips()">
              {{ $t('helpTips.popup.disableButton') }}
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
